
import isBlankStr from "underscore.string/isBlank"
import {
  MinMaxSelectWithChosen,
  InputSelector as BaseInputSelector,
  DEFAULT_SELECTOR as BASE_DEFAULT_SELECTOR,
} from "components/dropdown_menu/with_chosen"

export type InputSelector = BaseInputSelector & {
  scope?: string | JQuery
  main?: string
  min_select?: string
  max_select?: string
  toggle?: string
  dropdown?: string
  min_wrapper?: string
  max_wrapper?: string
}
const DEFAULT_SELECTOR = Object.assign({}, BASE_DEFAULT_SELECTOR, {
  scope:        ".cell-listing-filter",
  main:         ".cell-listing-filter__area-size-dropdown-container",
  min_select:   ".cell-listing-filter__minimum-area-size-input",
  max_select:   ".cell-listing-filter__maximum-area-size-input",
  toggle:       ".dropdown-with-input-toggle",
  dropdown:     ".dropdown-menu-with-input",
  max_wrapper:  ".filter-option--gross-max",
  min_wrapper:  ".filter-option--gross-min",
})


class AreaSizeDropdown extends MinMaxSelectWithChosen {
  protected name: string

  constructor(selector?: InputSelector){
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    super(merged_selector)

    this.name = "area_size_dropdown_blueprint"
  }

  protected onChange(e: Event){
    super.onChange(e)

    this.emit("val_change")
  }
  protected convertValueToLabel(){
    const min_value = this.$min_select.val()
    const max_value = this.$max_select.val()
    const min_label = this.$min_select.find("option:selected").text()
    const max_label = this.$max_select.find("option:selected").text()

    if (!isBlankStr(min_value) && !isBlankStr(max_value)){
      return `${min_label} - ${max_label}`
    }
    else if (!isBlankStr(min_value)){
      return `> ${min_label}`
    }
    else if ( !isBlankStr(max_value) ){
      return `< ${max_label}`
    }
    else{
      return this.$selected_text.data("original-text")
    }
  }
}


export {
  AreaSizeDropdown,
  DEFAULT_SELECTOR,
}
